// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {FileUploadOverlay} from './file_upload_overlay';

export default FileUploadOverlay;
